import { useState, useContext } from 'react';
import { useHistory } from 'react-router-dom';

import { User } from 'commons/models/marketingDashboard';
import { AppContext } from 'commons-ui';

import useService from '../../utils/useService';
import { FORM_FIELD_CONFIG, FORM_FIELD_KEYS } from '../../helper';
import { getFormDefaults } from './helper';

const useCreate = () => {
	const [showLoader, setShowLoader] = useState(false);
	const { showAlert, app } = useContext(AppContext);
	const { requestCreateUser, getRoleOptions } = useService();
	FORM_FIELD_CONFIG[FORM_FIELD_KEYS.ROLE_ID].setRenderProps({ getOptions: getRoleOptions });

	const data = getFormDefaults();

	const history = useHistory();

	const createUser = async (formData: User) => {
		setShowLoader(true);

		try {
			await requestCreateUser(app.appName, formData);
		} catch (e: any) {
			showAlert(e.response?.data?.error ?? 'Error while creating this user', { type: 'error' });
			setShowLoader(false);

			history.goBack();
			return;
		}
		showAlert('User created successfully', { type: 'success' });
		setShowLoader(false);

		history.goBack();
	};

	const handleFormSubmit = (formData: User) => {
		createUser(formData);
	};

	const handleFormCancel = () => {
		history.goBack();
	};

	return { data, showLoader, handleFormSubmit, handleFormCancel, setShowLoader };
};

export default useCreate;
